import afterLogin from '../assets/sounds/after_login.mp3';
import soundButton1 from '../assets/sounds/botoes_genericos_01.mp3';
import soundButton2 from '../assets/sounds/botoes_genericos_02.mp3';
import soundButton3 from '../assets/sounds/botoes_genericos_03.mp3';
import buttonSidebar01 from '../assets/sounds/botoes_laterais_01.mp3';
import buttonSidebar02 from '../assets/sounds/botoes_laterais_02.mp3';
import buttonSidebar03 from '../assets/sounds/botoes_laterais_03.mp3';
import dropCard1 from '../assets/sounds/carta_drop_01.mp3';
import dropCard2 from '../assets/sounds/carta_drop_02.mp3';
import dropCard3 from '../assets/sounds/carta_drop_03.mp3';
import selectCard1 from '../assets/sounds/carta_seleciona_01.mp3';
import selectCard2 from '../assets/sounds/carta_seleciona_02.mp3';
import selectCard3 from '../assets/sounds/carta_seleciona_03.mp3';
import levelUp from '../assets/sounds/level_up.mp3';
import musicaLoop01 from '../assets/sounds/musica_loop_01.mp3';
import musicaLoop02 from '../assets/sounds/musica_loop_02.mp3';
import sound1 from '../assets/sounds/popup_01.mp3';
import sound2 from '../assets/sounds/popup_02.mp3';
import sound3 from '../assets/sounds/popup_03.mp3';
import selectRightAnswer1 from '../assets/sounds/resposta_certa_01.mp3';
import selectWrongAnswer from '../assets/sounds/resposta_errada.mp3';
import roleta from '../assets/sounds/roleta.mp3';

export const soundEnvironment = {
  genericButtons: [
    soundButton1,
    soundButton2,
    soundButton3,
  ],
  sidebarButtons: [
    buttonSidebar01,
    buttonSidebar02,
    buttonSidebar03,
  ],
  modals: [
    sound1,
    sound2,
    sound3,
  ],
  backgroundLoop: [
    musicaLoop01,
    musicaLoop02,
  ],
  selectRightAnswer: [
    selectRightAnswer1,
  ],
  afterLogin,
  selectWrongAnswer,
  roleta,
  levelUp: [
    levelUp,
  ],
  dropCard: [
    dropCard1,
    dropCard2,
    dropCard3,
  ],
  selectCard: [
    selectCard1,
    selectCard2,
    selectCard3,
  ],
};
